import { render } from "./LoadingSkeletonCardButtomSecondary.vue?vue&type=template&id=db2134b4&ts=true"
import script from "./LoadingSkeletonCardButtomSecondary.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeletonCardButtomSecondary.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__